import { render, staticRenderFns } from "./ContactMenu.vue?vue&type=template&id=74b40eed&lang=pug"
import script from "./ContactMenu.vue?vue&type=script&lang=js"
export * from "./ContactMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports